import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("adminToken")}` });
const FILTERS = [["open", "Open"], ["dismissed", "Dismissed"], ["", "All"]];

function Toggle({ on, onLabel, offLabel, onAction, offAction, run, testid }) {
  return <button className={`px-3 py-1 text-xs border ${on ? "bg-[#0f1d2f] text-white" : ""}`} onClick={() => run(on ? offAction : onAction)} data-testid={testid}>{on ? offLabel : onLabel}</button>;
}

function ReportRow({ r, onChanged }) {
  const [note, setNote] = useState(r.admin_note || "");
  const run = (action, extra = {}) => axios.post(`${API}/admin/social/reports/${r.id}/action`, { action, ...extra }, { headers: auth() })
    .then(res => { toast.success("Saved"); onChanged(res.data); }).catch(e => toast.error(e.response?.data?.detail || "Could not update"));
  return (
    <li className="border p-4" data-testid={`report-row-${r.id}`}>
      <div className="text-sm"><strong>{r.subject.display_name}</strong>{r.subject.username && ` @${r.subject.username}`} · reason: {r.reason} · {new Date(r.created_at).toLocaleString()} · <span data-testid={`report-status-${r.id}`}>{r.status}</span></div>
      <div className="text-xs text-gray-600">Reported by {r.reporter.display_name}</div>
      {r.details && <p className="text-sm mt-2" style={{ overflowWrap: "anywhere" }}>{r.details}</p>}
      <div className="text-xs text-gray-600 mt-2" data-testid={`report-state-${r.id}`}>Hidden from search: {r.subject_state.search_hidden ? "yes" : "no"} · Friends paused: {r.subject_state.paused ? "yes" : "no"}</div>
      <div className="flex flex-wrap gap-2 mt-3">
        <Toggle on={r.status === "dismissed"} onLabel="Dismiss" offLabel="Reopen" onAction="dismiss" offAction="reopen" run={run} testid={`report-${r.id}-dismiss`} />
        <Toggle on={r.subject_state.search_hidden} onLabel="Hide from search" offLabel="Show in search" onAction="hide_search" offAction="unhide_search" run={run} testid={`report-${r.id}-hide`} />
        <Toggle on={r.subject_state.paused} onLabel="Pause Friends features" offLabel="Resume Friends features" onAction="pause" offAction="unpause" run={run} testid={`report-${r.id}-pause`} />
      </div>
      <div className="flex flex-wrap gap-2 mt-3">
        <input className="border p-2 text-sm flex-1 min-w-0" placeholder="Private admin note" value={note} onChange={e => setNote(e.target.value)} maxLength={1000} data-testid={`report-${r.id}-note`} />
        <button className="px-3 py-1 text-xs border" onClick={() => run("note", { note })} disabled={!note.trim()} data-testid={`report-${r.id}-note-save`}>Save note</button>
      </div>
      {r.audit.length > 0 && <details className="mt-3 text-xs text-gray-600"><summary>History ({r.audit.length})</summary><ul className="mt-1">{r.audit.map((a, i) => <li key={i}>{new Date(a.at).toLocaleString()} · {a.action}{a.note ? ` · ${a.note}` : ""}</li>)}</ul></details>}
    </li>
  );
}

export default function AdminSocialReports() {
  const [rows, setRows] = useState(null);
  const [filter, setFilter] = useState("open");
  useEffect(() => {
    axios.get(`${API}/admin/social/reports`, { params: { status: filter || undefined }, headers: auth() })
      .then(r => setRows(r.data.reports)).catch(() => setRows([]));
  }, [filter]);
  const replace = (u) => setRows(rs => rs.map(x => x.id === u.id ? u : x));
  return (
    <section className="px-6 pt-32 pb-24 max-w-4xl mx-auto" data-testid="admin-social-reports">
      <h1 className="font-serif text-3xl mb-2">Member reports</h1>
      <p className="text-sm text-gray-600 mb-6">Shows only the reported member's public card, the reporter, the reason and note. Emails, locations, purchases and larders are never shown. Every action is reversible and recorded.</p>
      <select className="border p-2 mb-6" value={filter} onChange={e => setFilter(e.target.value)} data-testid="reports-filter">
        {FILTERS.map(([v, l]) => <option key={l} value={v}>{l}</option>)}
      </select>
      {rows === null ? <p>Loading…</p> : rows.length === 0 ? <p data-testid="reports-empty">No reports.</p> : (
        <ul className="space-y-3">{rows.map(r => <ReportRow key={r.id} r={r} onChanged={replace} />)}</ul>)}
    </section>
  );
}
